(function() {
    angular
        .module('appback')
        .factory('batchselect2Service', batchSelect2Service);

    batchSelect2Service.$inject = ['$rootScope', '$timeout', '$q', '$http', 'GenerallabService'];

    function batchSelect2Service($rootScope, $timeout, $q, $http,GenerallabService) {
        var pendingIds = [];  // Lista para almacenar los objetos de las IDs recibidas
        var pendingDeferreds = [];  // Lista para almacenar las promesas asociadas a cada obj
        var currentRequestInProgress = false;  // Flag para saber si hay una petición en curso
        var timeoutPromise = null;  // Promesa de timeout para la petición final
        var generalLab = GenerallabService;
        // Función para realizar la petición agrupada
        function requestBatch(objReq) {
            //objReq.lang_id = lang_id;
            return $http.post('/backend/altcrm/content/getvalueselect2lote', 
                $.param({ 
                    objReq : JSON.stringify(objReq), 
                    lang_id : generalLab.user_lang_id
                }),
                {
                    ignoreLoadingBar: true
                }
            );
        }

        // Función para agregar un objeto (ID u otro valor) a la lista y controlar el batch
        function addId(obj) {
            var deferred = $q.defer();

            // Agregar el objeto a la lista de pendientes
            pendingIds.push(obj);
            pendingDeferreds.push(deferred);  // Guardamos también la promesa de esta ID

            // Si no hay un timeout en curso, configuramos uno
            if (!timeoutPromise) {
                timeoutPromise = $timeout(function() {
                    // Ejecutar la petición si no hay una en curso
                    if (!currentRequestInProgress) {
                        processBatch();
                    } else {
                        // Si ya hay una petición en curso, simplemente limpiamos el timeout
                        timeoutPromise = null;
                    }
                }, 500);  // Tiempo de espera para acumular más objetos
            }

            return deferred.promise;
        }

        // Función para procesar el lote actual
        function processBatch() {
            var currentObj = pendingIds.slice();  // Hacemos una copia de los objetos actuales
            var currentDeferreds = pendingDeferreds.slice();  // Copiamos las promesas actuales

            // Limpiamos la lista para el siguiente lote
            pendingIds = [];
            pendingDeferreds = [];
            currentRequestInProgress = true;  // Marcamos que hay una petición en curso

            requestBatch(currentObj).then(function(response) {
                // Resolver todas las promesas pendientes con los datos recibidos
                currentDeferreds.forEach(function(deferred) {
                    deferred.resolve(response.data);
                });
            }).catch(function(error) {
                // Rechazar todas las promesas en caso de error
                currentDeferreds.forEach(function(deferred) {
                    deferred.reject(error);
                });
            }).finally(function() {
                currentRequestInProgress = false;  // Petición completada
                timeoutPromise = null;  // Limpiar el timeout

                // Iniciar el siguiente lote si hay más IDs
                if (pendingIds.length > 0) {
                    processBatch();
                }
            });
        }

        return {
            addId: addId
        };
    }
})();